import { useCallback } from "react";
import { useKameleoon } from "./useKameleoon";
const useTrackingConversion = () => {
    const kameleoon = useKameleoon();
    const trackConversion = useCallback(({ goalId }) => {
        if (!kameleoon) {
            return;
        }
        kameleoon.trackConversion({ goalId: Number(goalId) });
    }, [kameleoon]);
    return trackConversion;
};
export { useTrackingConversion };
